import React, { useState } from "react";
import {
	Collapse,
	IconButton,
	Box,
	SelectProps,
	Typography,
	Button,
	useMediaQuery,
} from "@mui/material";
import { ExpandMore, ExpandLess } from "@mui/icons-material";
import AddSubaccountModal from "./AddSubaccountModal";
import { useTraderProvider } from "../../providers/TraderProvider";
import { useAuth } from "../../providers/AuthenticationProvider";
import { useTranslation } from "react-i18next";

interface AccountSubAccountProps {}

const AccountSubAccount: React.FC<AccountSubAccountProps> = () => {
	const { changeCurrentTrader } = useTraderProvider();
	const { traderProfile } = useAuth();
	const [open, setOpen] = useState(false);
	const [selectedValue, setSelectedValue] = useState("");
	const [anchorEl, setAnchorEl] = useState<HTMLElement | null>(null);
	const [openModal, setOpenModal] = useState(false);
	const { t } = useTranslation();
	const handleToggle = (event: React.MouseEvent<HTMLButtonElement>) => {
		setOpen(!open);
		setAnchorEl(event.currentTarget);
	};

	const handleClose = () => {
		setOpen(false);
	};

	const handleChange = (event: any) => {
		setSelectedValue(event.target.value as string);
		setOpen(false);
	};

	const isSmallScreen = useMediaQuery((theme: any) =>
		theme.breakpoints.down("sm")
	);

	const menuProps: SelectProps["MenuProps"] = {
		anchorEl,
		onClose: handleClose,
		open,
		MenuListProps: {
			"aria-labelledby": "basic-button",
		},
	};

	return (
		<Box
			sx={{
				position: "relative",
				display: "inline-block",
				alignSelf: { xs: "flex-end", sm: "unset" },
				justifySelf: { xs: "flex-end", sm: "unset" },
			}}
		>
			<AddSubaccountModal open={openModal} setOpen={setOpenModal} />
			<IconButton onClick={handleToggle} sx={{ background: "#393E4D" }}>
				{open ? <ExpandLess /> : <ExpandMore />}
			</IconButton>
			<Collapse
				in={open}
				style={{
					position: "absolute",
					top: "100%",
					zIndex: 1,
					left: isSmallScreen ? "50%" : "auto",
					transform: isSmallScreen ? "translateX(-60%)" : "none",
				}}
			>
				<Box
					flex={1}
					maxWidth={window.innerWidth - 50}
					sx={{
						display: "flex",
						justifyContent: "center",
						alignItems: "center",
						flexDirection: "column",
						padding: "16px",
						borderRadius: "8px",
						background:
							"linear-gradient(to bottom, #222838 0%, #147b7a 100%)",
					}}
				>
					{traderProfile != null && (
						<Button
							onClick={() =>
								changeCurrentTrader(traderProfile?.uid)
							}
						>
							<Typography
								variant="body1"
								fontSize="12px"
								whiteSpace="nowrap"
								color="white"
							>
								{traderProfile?.username}
								{isSmallScreen ? (
									""
								) : (
									<> | {traderProfile?.uid}</>
								)}
							</Typography>
						</Button>
					)}
					<Box
						maxHeight="400px"
						sx={{
							overflowY: "scroll",
							scrollbarWidth: "thin",
							scrollbarColor: "#147A7A",
						}}
					>
						{traderProfile != null &&
							traderProfile.subAccountsUsername != null &&
							traderProfile.subAccountsUsername.map(
								(value, index) => (
									<Button
										key={index}
										onClick={() =>
											changeCurrentTrader(value.uid)
										}
									>
										<Typography
											color="white"
											variant="body1"
											fontSize="12px"
											whiteSpace="nowrap"
										>
											{value.username}
											{isSmallScreen ? (
												""
											) : (
												<> | {value?.uid}</>
											)}
										</Typography>
									</Button>
								)
							)}
					</Box>
					<br
						style={{
							height: "2px",
							width: "100%",
							background: "red",
						}}
					/>
					<Button
						onClick={() => {
							setOpenModal(true);
						}}
					>
						<Typography color="white" variant="body1">
							{t("trader.sub_account.add_account")}
						</Typography>
					</Button>
				</Box>
			</Collapse>
		</Box>
	);
};

export default AccountSubAccount;
